import React, { useState } from 'react';
import { useSendOtpMutation, useVerifyOtpMutation, useGetPaymentsByMobileMutation } from '../redux/api/roomBookingApi';

const PaymentHistory = () => {
    const [mobile, setMobile] = useState('');
    const [otp, setOtp] = useState('');
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [otpSent, setOtpSent] = useState(false);

    const [sendOtp] = useSendOtpMutation();
    const [verifyOtp] = useVerifyOtpMutation();
    const [getPayments, { data: paymentsData, isLoading }] = useGetPaymentsByMobileMutation();

    const handleSendOtp = async (e) => {
        e.preventDefault();
        if (mobile.length !== 10) return alert("Enter valid mobile number");

        try {
            const res = await sendOtp({ phone: mobile }).unwrap();
            if (res.status === 'success') {
                if (process.env.REACT_APP_ENABLE_SANDBOX_OTP === 'true') {
                    alert(`OTP Sent to ${mobile}` + (res.otp ? ` (Sandbox: ${res.otp})` : ''));
                } else {
                    alert(`OTP Sent to ${mobile}`);
                }
                setOtpSent(true);
                setShowOtpInput(true);
                // if (res.otp) setOtp(res.otp); // Pre-fill for easier testing removed
            }
        } catch (err) {
            console.error("OTP Error", err);
            alert("Error sending OTP");
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        try {
            const res = await verifyOtp({ phone: mobile, otp }).unwrap();
            if (res.status === 'success' && res.verified) {
                alert("Verified! Fetching History...");
                setIsVerified(true);
                setShowOtpInput(false);
                fetchHistory();
            } else {
                alert("Invalid OTP");
            }
        } catch (err) {
            console.error("Verification Error", err);
            alert("Error verifying OTP");
        }
    };

    const fetchHistory = async () => {
        try {
            await getPayments({ mobile }).unwrap();
        } catch (err) {
            console.error("Fetch Error", err);
        }
    };

    return (
        <div className="space-top space-extra-bottom">
            <div className="container">
                <div className="title-area text-center mb-5">
                    <h2 className="sec-title" style={{ color: '#c20000' }}>My Payment History</h2>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        {!isVerified ? (
                            <div className="card shadow-sm p-4">
                                <h4 className="mb-4">Verify Mobile Number</h4>
                                <form onSubmit={!showOtpInput ? handleSendOtp : handleVerifyOtp}>
                                    <div className="form-group mb-3">
                                        <label>Mobile Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={mobile}
                                            onChange={(e) => setMobile(e.target.value)}
                                            disabled={showOtpInput}
                                            placeholder="Enter 10-digit mobile"
                                            maxLength={10}
                                        />
                                    </div>
                                    {showOtpInput && (
                                        <div className="form-group mb-3">
                                            <label>Enter OTP</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                                                placeholder="Enter the 6-digit OTP"
                                                maxLength="6"
                                            />
                                        </div>
                                    )}
                                    <button type="submit" className="th-btn w-100">
                                        {!showOtpInput ? "Send OTP" : "Verify & View History"}
                                    </button>
                                </form>
                            </div>
                        ) : (
                            <div className="payment-history-results">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h4>Transactions for {mobile}</h4>
                                    <button className="btn btn-sm btn-outline-secondary" onClick={() => window.location.reload()}>Back</button>
                                </div>

                                {isLoading && <div className="text-center">Loading...</div>}

                                {paymentsData && paymentsData.data && paymentsData.data.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Booking ID</th>
                                                    <th>Type</th>
                                                    <th>Details</th>
                                                    <th>Amount</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paymentsData.data.map((txn, index) => (
                                                    <tr key={index}>
                                                        <td>{new Date(txn.date).toLocaleDateString('en-GB')}</td>
                                                        <td>{txn.booking_id}</td>
                                                        <td>{txn.type}</td>
                                                        <td>{txn.details}</td>
                                                        <td style={{ fontWeight: 'bold' }}>₹{txn.amount}</td>
                                                        <td>
                                                            <span className={`badge ${txn.pay_status === 'completed' ? 'bg-success' : 'bg-warning'}`}>
                                                                {(txn.pay_status || 'Pending').toUpperCase()}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {txn.receipt_type === 'seva' && txn.pay_status === 'completed' && (
                                                                <button
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={() => downloadReceipt(txn._id, 'seva')}
                                                                >
                                                                    <i className="fa fa-download"></i> Receipt
                                                                </button>
                                                            )}
                                                            {txn.receipt_type === 'room' && txn.pay_status === 'completed' && (
                                                                <button
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={() => downloadReceipt(txn.booking_id, 'room')}
                                                                >
                                                                    <i className="fa fa-download"></i> Receipt
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    !isLoading && <div className="alert alert-info">No booking history found for this mobile number.</div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

// Add download function outside or inside component
const downloadReceipt = async (id, type) => {
    try {
        const url = type === 'seva' ? '/api/payment/receipt/seva' : '/api/payment/receipt/room';
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        });

        if (!response.ok) throw new Error("Failed to download");

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `receipt_${type}_${id}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (err) {
        console.error(err);
        alert("Error downloading receipt: " + err.message);
    }
};

export default PaymentHistory;
